
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.75 7.292a5.25 5.25 0 0010.2 1.75m-10.2-1.75L3.5 8.457M1.75 7.291L.582 9.041m11.666-2.333a5.25 5.25 0 00-10.2-1.75m10.2 1.75L10.5 5.541m1.75 1.167l1.167-1.75","stroke":"#748190","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    